import { ButtonSize } from "../../../classes/enums/ButtonEnum";
import IconsEnum from "../../../classes/enums/IconsEnum";
import { roundToUnit } from "../../../classes/utils/NumbersUtils";
import IconButton from "../../../components/iconButton/IconButton";
import "./Spp.css";

const CustomSppParameter = ({
  param,
  onSppSelected,
  isVisible,
  onRemove,
  disabled = false,
}) => {
  const renderValue = (value, defaultValue) => {
    return (
      <span className={`Spp-measurement-value`}>
        {roundToUnit(value) ?? defaultValue}
      </span>
    );
  };

  // Debug: Let's see what properties are available
  // Get the display name - try different possible property names
  const displayName =
    param.shortName ||
    param.name ||
    `Measurement ${param.measurementId || param.key}`;
  const unit = param.unit || "mm";
  const value = param.originalValue || param.value;

  const handleRemoveClick = e => {
    e.stopPropagation(); // Prevent event bubbling to parent div
    if (!disabled) {
      onRemove(param);
    }
  };

  return (
    <div className="spp-parameter">
      <div
        className="Analyse-spp-option App-text-medium"
        onClick={() => {
          if (!disabled) {
            onSppSelected(param);
          }
        }}
        style={disabled ? { pointerEvents: "none", opacity: 0.6 } : undefined}
      >
        <div className={`App-option-circle ${isVisible ? "active" : ""}`}></div>
        <span className="Spp-measurement-name">
          {displayName} [{unit}]
        </span>
        {renderValue(value, "-")}
        <IconButton
          icon={IconsEnum.DELETE}
          onClick={handleRemoveClick} // ← Now prevents bubbling
          isCircle
          size={ButtonSize.SMALL}
          noBgColor={true}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default CustomSppParameter;
